import React, { useState } from 'react';
import classnames from 'classnames';
import { useIntl } from 'react-intl'

import { useReturnState } from '../ReturnsPageApp';
import { makeBtStyles } from '../Theme';
import Button from '../components/Button';

import ReturnShippingDescriptor from './ReturnShippingDescriptor';
import axios from 'axios';


const useStyles = makeBtStyles( theme => ({
  root: {
    width: '780px'
  },
  cardHeader: {
    display: 'flex',
    justifyContent: 'space-between'
  },
  heading: {
    ...theme.characteristicFont,
    fontSize: '21px',
    margin: 0
  },
  orderNumber: {
    fontWeight: '500',
    fontSize: '16px'
  },
  dateHeader: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'space-between',
    textAlign: 'right',
    fontSize: '14px'
  },
  dateLabel: {
    fontWeight: '600'
  },    
  shippingDescriptor: {
    marginTop: '20px'
  },
  button: {
    marginTop: '40px',
    fontSize: '16px'
  },
  error: {
    marginTop: '20px',
    color: '#E73434'
  }
}));


export default function ConfigureReturn({ className='' }) {
  const classes = useStyles();
  const { order, setLabel } = useReturnState();
  const [rateReady,setRateReady] = useState(false);
  const [loading,setLoading] = useState(false);
  const [error,setError] = useState<string|null>();
  const intl = useIntl();

  const onCreate = () => {
    setLoading(true);
    axios.get('/create-returnXXX').then(
      (response) => {
        setLoading(false);
        setError(null);
        setLabel(response.data);
      },
      (error) => {
        setLoading(false);
        setError(error);
      }
    );
  }

  const onRateNoticeLoaded = () => setRateReady(true);

  return <div className={classnames(classes.root,className)}>
    <div className={classes.cardHeader}>
      <div>
        <h2 className={classes.heading}>Create Return Request</h2>
        <div className={classes.orderNumber}>Order No. {order.external_order_number}</div>
      </div>
      <div className={classes.dateHeader}>
        <div>
          <label className={classes.dateLabel}>Order Date:</label>
          <span>{intl.formatDate(order.order_date, { dateStyle: 'medium' })}</span>
        </div>
        <div>{order.days_left_to_return} days left to return</div>
      </div>
    </div>

    <ReturnShippingDescriptor onRateNoticeLoaded={onRateNoticeLoaded} className={classes.shippingDescriptor} />

    <Button variant="primary" className={classes.button} onClick={onCreate} disabled={loading || !rateReady}>
      { loading ? 'Creating Return Label' : 'Create Return Label' }
    </Button>

    { error &&
      <div className={classes.error}>
        There was a problem creating your return label.
        <div>{JSON.stringify(error)}</div>
      </div>
    }
  </div>;
}
